<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <div class="main">
      <div class="main-right" ref="mainRight">
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{ CatalogueName }}</span>
          </div>
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
                  {{ DropDownedName }}<i class="el-icon-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="status-dropdown">
                  <el-dropdown-item command="a">全部</el-dropdown-item>
                  <el-dropdown-item command="b">主诉</el-dropdown-item>
                  <el-dropdown-item command="c">现病史</el-dropdown-item>
                  <el-dropdown-item command="d">既往史</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;" @keyup.enter.native="loadData"></el-input>
            </div>
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleShowKeyWord">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name"
                             header-align="center">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148" v-if="$store.getters.hasPermission('system:seedoctorKeyword:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleEditOnCredit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.state === 1 ? 'danger' : 'success' "
                             @click="handleEditByState(scope.row)" size="mini">
                    {{ scope.row.state === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
                class="fixed-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[8, 10, 20]"
                :page-size="pageSize"
                :total="totalSize"
                layout="total, sizes, prev, pager, next, jumper"
                background
                style="margin-top: 10px;">
            </el-pagination>
          </div>
        </div>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :title="showSeeDoctorKeywordDialogVisible ? '查看' : addSeeDoctorKeywordForm.id ? '修改' : '新增'"
            :visible.sync="addSeeDoctorKeywordDialogVisible"
            :close-on-click-modal="false"
            width="50%"
            @close="handleCloseAddSeeDoctorKeyword"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="addSeeDoctorKeywordForm"
              ref="addSeeDoctorKeywordForm"
              :rules="addSeeDoctorKeywordFormRules"
              label-width="110px"
              label-position="right"
              :disabled="showSeeDoctorKeywordDialogVisible"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="名称:" prop="name">
                  <el-input
                      v-model="addSeeDoctorKeywordForm.name"
                      @input="handleOnCreditNameGetPy"
                      placeholder="请输入完整名称"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="类型:" prop="type">
                  <el-select
                      v-model="addSeeDoctorKeywordForm.type"
                      placeholder="请选择状态"
                      style="width: 100%"
                      @change="handleClearGroupType"
                  >
                    <el-option
                        v-for="item in nodeTypeOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="父节点:" prop="parentId">
                  <el-cascader
                      v-model="addSeeDoctorKeywordForm.parentId"
                      :options="parentOptions"
                      :props="cascaderProps"
                      placeholder="请选择父节点"
                      clearable
                      filterable
                      style="width:100%"
                      @change="handleParentChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="主诉类型:" prop="mainGroup">
                  <el-select
                      v-model="addSeeDoctorKeywordForm.mainGroup"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                      :disabled="addSeeDoctorKeywordForm.type !== 1"
                  >
                    <el-option
                        v-for="item in mainGroupOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="既往史类型:" prop="beforeHistoryGroup">
                  <el-select
                      v-model="addSeeDoctorKeywordForm.beforeHistoryGroup"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                      :disabled="addSeeDoctorKeywordForm.type !== 3"
                  >
                    <el-option
                        v-for="item in beforeHistoryGroupOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="现病史类型:" prop="nowHistoryGroup">
                  <el-select
                      v-model="addSeeDoctorKeywordForm.nowHistoryGroup"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                      :disabled="addSeeDoctorKeywordForm.type !== 2"
                  >
                    <el-option
                        v-for="item in nowHistoryGroupOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showSeeDoctorKeywordDialogVisible" size="mini" type="primary" @click="handleAddSeeDoctorKeyword">保存</el-button>
            <el-button :disabled="showSeeDoctorKeywordDialogVisible" size="mini" @click="handleCloseAddSeeDoctorKeyword">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { pinyin } from "pinyin-pro";
import { withLoading } from "@/untils/loading";
import {
  addSeeDoctorKeyword,
  editSeeDoctorKeyword,
  getSeeDoctorKeyword,
  getSeeDoctorKeywordList
} from "@/api/seedoctorKeyword/seedoctorKeyword";

// 工厂函数：生成空表单
const getEmptyForm = () => ({
  id: null,
  mainGroup: null,
  beforeHistoryGroup: null,
  nowHistoryGroup: null,
  parentId: null,
  type: null,
  name: '',
});

export default {
  data() {
    return {
      // 基础数据
      CatalogueName: '病历关键字',
      DropDownedName: '全部',
      iconComes: 'el-icon-byj',
      loading: false,

      // 查询条件
      queryConditionForm: {
        name: '',
        type: null,
      },

      // 对话框控制
      addSeeDoctorKeywordDialogVisible: false,
      showSeeDoctorKeywordDialogVisible: false,

      // 分页
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      // 表单数据
      addSeeDoctorKeywordForm: getEmptyForm(),
      addSeeDoctorKeywordFormRules: {
        parentId: [{ required: true, message: '请选择父节点', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        mainGroup: [{
          validator: (rule, value, callback) => {
            if (this.addSeeDoctorKeywordForm.type === 1 && !value) {
              callback(new Error('主诉类型必填'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        beforeHistoryGroup: [{
          validator: (rule, value, callback) => {
            if (this.addSeeDoctorKeywordForm.type === 3 && !value) {
              callback(new Error('既往史类型必填'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        nowHistoryGroup: [{
          validator: (rule, value, callback) => {
            if (this.addSeeDoctorKeywordForm.type === 2 && !value) {
              callback(new Error('现病史类型必填'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },

      // 下拉选项
      groupTypeOption: [
        { id: 0, label: '根节点' },
        { id: 1, label: '呼吸' },
        { id: 2, label: '消化' },
        { id: 3, label: '心脏血管' },
        { id: 4, label: '外科' }
      ],
      nodeTypeOption: [
        { id: 1, label: '主诉' },
        { id: 2, label: '现病史' },
        { id: 3, label: '既往史' }
      ],
      mainGroupOption: [
        { id: 1, label: '呼吸' },
        { id: 2, label: '消化' },
        { id: 3, label: '心脏血管' },
        { id: 4, label: '外科' }
      ],
      beforeHistoryGroupOption: [
        { id: 1, label: '默认' },
        { id: 2, label: '既往有' },
        { id: 3, label: '个人史' }
      ],
      nowHistoryGroupOption: [
        { id: 1, label: '诱因' },
        { id: 2, label: '特征' },
        { id: 3, label: '兼症' },
        { id: 4, label: '精神' },
        { id: 5, label: '睡眠' },
        { id: 6, label: '饮食' },
        { id: 7, label: '二便' },
        { id: 8, label: '体态' }
      ],

      parentOptions: [],       // 级联选择器树形数据
      parentIdMap: {},         // 扁平映射 id -> name，用于表格显示
      cascaderProps: {
        checkStrictly: false,
        value: 'id',
        label: 'label',
        children: 'children'
      },
      tableData: [],
      tableRows: [
        { name: "名称", prop: "name" },
        { name: "节点类型", prop: "type", op: 'nodeTypeOption' },
        { name: "分组类型", prop: "groupType", op: 'groupTypeOption' },
        { name: "父节点", prop: "parentId" },   // 注意：不再使用 op，由 safeGetMappedValue 特殊处理
        { name: "创建时间", prop: "createTime" }
      ],

      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
        { add: "add", title: "新增", type: "warning", auth: 'system:seedoctorKeyword:add' }
      ],
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // 重置表单
    resetForm() {
      this.addSeeDoctorKeywordForm = getEmptyForm();
      this.$nextTick(() => {
        this.$refs.addSeeDoctorKeywordForm?.clearValidate();
      });
    },

    // 类型切换时清空无关分组字段
    handleClearGroupType(value) {
      switch (value) {
        case 1: // 主诉
          this.addSeeDoctorKeywordForm.beforeHistoryGroup = null;
          this.addSeeDoctorKeywordForm.nowHistoryGroup = null;
          break;
        case 2: // 现病史
          this.addSeeDoctorKeywordForm.mainGroup = null;
          this.addSeeDoctorKeywordForm.beforeHistoryGroup = null;
          break;
        case 3: // 既往史
          this.addSeeDoctorKeywordForm.mainGroup = null;
          this.addSeeDoctorKeywordForm.nowHistoryGroup = null;
          break;
      }
    },

    // 父节点变化时，自身不能选自身或后代（简单提醒，实际由后台逻辑保证）
    handleParentChange(val) {
      if (Array.isArray(val) && val.includes(this.addSeeDoctorKeywordForm.id)) {
        this.$message.warning('不能选择自身或包含自身的节点作为父节点');
        this.addSeeDoctorKeywordForm.parentId = null;
      }
    },

    // 名称转拼音（虽然可能用不到，保留原有逻辑）
    handleOnCreditNameGetPy() {
      this.addSeeDoctorKeywordForm.pycode = pinyin(this.addSeeDoctorKeywordForm.name, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },

    // 双击查看
    handleShowKeyWord(row) {
      this.addSeeDoctorKeywordForm = { ...row };
      // 将分组字段中的 0 转为 null
      ['mainGroup', 'beforeHistoryGroup', 'nowHistoryGroup'].forEach(field => {
        if (this.addSeeDoctorKeywordForm[field] === 0) {
          this.addSeeDoctorKeywordForm[field] = null;
        }
      });
      this.addSeeDoctorKeywordDialogVisible = true;
      this.showSeeDoctorKeywordDialogVisible = true;
    },

    // 编辑按钮
    handleEditOnCredit(row) {
      this.addSeeDoctorKeywordForm = { ...row };
      ['mainGroup', 'beforeHistoryGroup', 'nowHistoryGroup'].forEach(field => {
        if (this.addSeeDoctorKeywordForm[field] === 0) {
          this.addSeeDoctorKeywordForm[field] = null;
        }
      });
      this.addSeeDoctorKeywordDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addSeeDoctorKeywordForm?.clearValidate();
      });
    },

    // 启用/禁用
    async handleEditByState(row) {
      const action = row.state === 1 ? '禁用' : '启用';
      try {
        await this.$confirm(`确认要${action} ${row.name} 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await withLoading(this, '请求处理中...')(async () => {
          const newItem = JSON.parse(JSON.stringify(row));
          newItem.state = row.state === 1 ? 0 : 1;
          const res = await editSeeDoctorKeyword(newItem);
          if (res.code === 200) {
            await this.loadData();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      } catch (error) {
        if (error !== 'cancel') console.error(error);
      }
    },

    // 保存（新增/编辑）
    async handleAddSeeDoctorKeyword() {
      try {
        await this.$refs.addSeeDoctorKeywordForm.validate();
      } catch {
        this.$message.warning("请填写完整表单");
        return;
      }

      const formData = {
        ...this.addSeeDoctorKeywordForm,
        parentId: Array.isArray(this.addSeeDoctorKeywordForm.parentId)
            ? this.addSeeDoctorKeywordForm.parentId[this.addSeeDoctorKeywordForm.parentId.length - 1]
            : this.addSeeDoctorKeywordForm.parentId
      };

      // 将 null/undefined 的分组字段转为 0
      ['mainGroup', 'beforeHistoryGroup', 'nowHistoryGroup'].forEach(field => {
        if (formData[field] == null) formData[field] = 0;
      });

      await withLoading(this, '数据提交中...')(async () => {
        const res = formData.id
            ? await editSeeDoctorKeyword(formData)
            : await addSeeDoctorKeyword(formData);
        if (res.code === 200) {
          this.handleCloseAddSeeDoctorKeyword();
          await this.loadData();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    // 关闭对话框并重置
    handleCloseAddSeeDoctorKeyword() {
      this.resetForm();
      this.addSeeDoctorKeywordDialogVisible = false;
      this.showSeeDoctorKeywordDialogVisible = false;
    },

    // 构建级联选择器的树形数据
    buildTree(items, parentId = 0) {
      const result = [];
      for (const item of items) {
        if (item.parentId === parentId) {
          const children = this.buildTree(items, item.id);
          if (children.length) {
            item.children = children;
          }
          result.push(item);
        }
      }
      return result;
    },

    // 加载数据
    async loadData() {
      try {
        const res = await getSeeDoctorKeyword({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name ?? '',
          type: this.queryConditionForm.type ?? null
        });
        if (res.code === 200) {
          // 获取所有节点用于构建级联选项和映射
          const res2 = await getSeeDoctorKeywordList();
          const allItems = (res2.data || []).map(item => ({
            id: item.id,
            label: `${item.name} (ID: ${item.id})`,
            parentId: item.parentId,
            name: item.name
          }));
          // 构建扁平映射 id -> name（用于表格显示父节点）
          this.parentIdMap = { 0: '根节点' };
          allItems.forEach(item => {
            this.parentIdMap[item.id] = item.name;
          });
          // 构建树形数据用于级联选择器
          this.parentOptions = this.buildTree(allItems, 0);
          // 添加一个根节点选项（可选，但级联选择器根节点已经包含 parentId=0 的节点）
          // 注意：如果根节点（parentId=0）没有出现在 allItems 中，需要手动添加
          const hasRoot = allItems.some(item => item.id === 0);
          if (!hasRoot) {
            this.parentOptions.unshift({ id: 0, label: '根节点', parentId: -1 });
          }

          this.totalSize = res.data.totalSize || 0;
          this.tableData = res.data.content || [];
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("系统异常:请联系管理员");
      }
    },

    // 顶部按钮
    async handClick(i) {
      if (i === 0) {
        await this.loadData();
      } else if (i === 1) {
        this.resetForm();
        this.addSeeDoctorKeywordDialogVisible = true;
      }
    },

    // 状态下拉筛选（全部/主诉/现病史/既往史）
    async handleCommand(command) {
      const typeMap = { b: 1, c: 2, d: 3 };
      this.queryConditionForm.type = typeMap[command] ?? null;
      await this.loadData();
      this.DropDownedName =
          this.queryConditionForm.type === 1 ? '主诉'
              : this.queryConditionForm.type === 2 ? '现病史'
                  : this.queryConditionForm.type === 3 ? '既往史' : '全部';
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格映射（增强：支持 parentId 映射）
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      // 特殊处理父节点字段
      if (col.prop === 'parentId') {
        return this.parentIdMap[rawValue] || rawValue;
      }
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 列宽计算（保留原有逻辑）
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>

<style lang="less" scoped>
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}
/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog {
  .showDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

    .feetbtn {
      display: flex;
      justify-content: center;
      margin-left: 12px;
    }
  }

  // main
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // height: 473px; /* 设置父容器的高度 */
    // overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {
        flex: 1;
        overflow: auto;

        .el-table {
          width: 100% !important;
          min-width: 800px; /* 关键：确保表格最小宽度 */

          /deep/ .cell {
            font-size: 12px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          /deep/ .el-table__body-wrapper {
            overflow-x: auto; /* 关键：表格水平滚动 */
          }
        }
      }
    }
  }

  // addModel
  .addModel {
    margin-left: 12px;

    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  .editModel {
    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  // feet
  .feet {
    padding: 12px;

  }

}
</style>